const measure = function (hidden = false) {
    const div1 = window.document.createElement('div');
    const div2 = window.document.createElement('div');

    div1.style.width = '100px';
    div1.style.overflowX = 'scroll';
    if (hidden) {
        div1.classList.add('hidden-scrollbar');
    }
    div2.style.width = '100px';

    window.document.body.appendChild(div1);
    window.document.body.appendChild(div2);

    const scrollbarSize = div1.offsetHeight - div2.offsetHeight;

    window.document.body.removeChild(div1);
    window.document.body.removeChild(div2);

    return scrollbarSize;
};

let scrollbarSize;
export function visibleScrollbarSize() {
    if (scrollbarSize != null) {
        return scrollbarSize;
    }

    scrollbarSize = measure();
    return scrollbarSize;
}

let hiddenScrollbarSize;
export function inVisibleScrollbarSize() {
    if (hiddenScrollbarSize != null) {
        return hiddenScrollbarSize;
    }

    hiddenScrollbarSize = measure(true);
    return hiddenScrollbarSize;
}

export default visibleScrollbarSize;
